import { MobileContainer, MobileDataRow, MobileLabelRow } from '../styles';
import { TableProps } from './table-dekstop';

export const TableMobile = ({ data, columns }: TableProps) => (
  <MobileContainer className="caption-regular">
    <MobileLabelRow>
      {columns.slice(1).map((column) => (
        <p key={column.id}>{column.label}</p>
      ))}
    </MobileLabelRow>
    {data.map((row) => (
      <MobileDataRow key={row.printer}>
        <p>{row.printer}</p>
        <div>
          {columns.slice(1).map((column) => (
            <p key={column.id}>{row[column.id as keyof typeof row]}</p>
          ))}
        </div>
      </MobileDataRow>
    ))}
  </MobileContainer>
);
